import { gql } from '@apollo/client';

export const REMOVE_UNAVAILABLE_LINEITEMS = gql`
    mutation RemoveUnavailableLineItems($cartId: String!, $lineItemIds: [String!]!) {
        removeLineItems(cartId: $cartId, lineItemIds: $lineItemIds) {
            id
        }
    }
`;
